import { useState, useEffect, useCallback } from 'react';
import pageService from '../services/pageService';
import { toast } from 'sonner';

const usePages = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');

  const fetchPages = useCallback(async (searchQuery = '') => {
    try {
      setLoading(true);
      const response = await pageService.getPages(searchQuery);
      if (response.success) {
        setPages(response.data);
      } else {
        setError(response.message);
        toast.error(response.message || 'Failed to fetch pages');
      }
    } catch (err) {
      setError(err.message);
      toast.error('An error occurred while fetching pages');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchPages(search);
    }, 300);
    return () => clearTimeout(handler);
  }, [search, fetchPages]);

  const deletePage = async (id) => {
    try {
      const response = await pageService.deletePage(id);
      if (response.success) {
        toast.success('Page deleted successfully');
        setPages(prev => prev.filter(p => p.id !== id));
        return true;
      } else {
        toast.error(response.message || 'Failed to delete page');
        return false;
      }
    } catch (err) {
      toast.error('An error occurred while deleting the page');
      return false;
    }
  };

  return {
    pages,
    loading,
    error,
    refreshPages: fetchPages,
    deletePage,
    search,
    setSearch
  };
};

export default usePages;
